import { render, staticRenderFns } from "./UserDialog.vue?vue&type=template&id=059074bc&scoped=true"
import script from "./UserDialog.vue?vue&type=script&lang=js"
export * from "./UserDialog.vue?vue&type=script&lang=js"
import style0 from "./UserDialog.vue?vue&type=style&index=0&id=059074bc&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059074bc",
  null
  
)

export default component.exports